import React, { useEffect, useState } from 'react';
import 'react-toastify/dist/ReactToastify.css';

const ToastContainer = () => {
  const [ToastComponents, installToastComponents] = useState({});

  useEffect(() => {
    import('react-toastify').then(({ Slide, ToastContainer }) => {
      installToastComponents({
        Slide,
        ToastContainerComponent: ToastContainer,
      });
    });
  }, [installToastComponents]);

  const { Slide, ToastContainerComponent } = ToastComponents;
  if (!ToastContainerComponent) return null;

  return (
    <ToastContainerComponent
      className="notification-container"
      position="bottom-center"
      transition={Slide}
      closeButton={false}
      draggable={false}
      autoClose={4000}
      limit={1}
    />
  );
};

export default ToastContainer;
